import * as types from "../actions/actionTypes";
import initialState from "./initialState";

export default function myProgressedJobsReducer(state = initialState.myProgressedJobs, action) {
  switch (action.type) {
    case types.LOAD_MY_PROGRESSED_JOBS_SUCCESS:
      return action.myProgressedJobs;

    default:
      return state;
  }
}
